import { render, staticRenderFns } from "./FileUploader.vue?vue&type=template&id=54e34aae&scoped=true"
import script from "./FileUploader.vue?vue&type=script&lang=ts"
export * from "./FileUploader.vue?vue&type=script&lang=ts"
import style0 from "./FileUploader.vue?vue&type=style&index=0&id=54e34aae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e34aae",
  null
  
)

export default component.exports